import _get from 'lodash/get';

export const getCurrentPath = state => _get(state, 'routing.currentPath', '');

export const getCurrentRoute = state => _get(state, 'routing.currentRoute', '');

export const isTopLevelRoute = state => _get(state, 'routing.isTopLevelRoute', false);

export const isOpenedViaDeeplink = state => _get(state, 'routing.isOpenedViaDeeplink', false);

export const shouldDisplayLanding = state => _get(state, 'routing.shouldDisplayLanding');

export const isNavigationAllowed = state => {
  const isAllowedByRoute = isTopLevelRoute(state);

  return isAllowedByRoute && state.layout.navigationAllowed;
};

export const getDeepLink = state => _get(state, 'routing.deeplink');

export const getRouteSkeleton = state => _get(state, 'routing.skeleton', '');
